import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { AuditLogs } from "../../../Constant";
import { H5, LI, P, UL } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { AUDIT_LOG } from "../../../Data/Dashboard";

const AuditLog = () => {
  return (
    <Col xl="3" md="7" sm="12" className="box-col-3 pre-order">
      <Card>
        <CommonCardHeader title={AuditLogs} />
        <CardBody className="py-1">
          <UL className="message-box theme-scrollbar simple-list">
            {AUDIT_LOG.map((item, index) => (
              <LI key={index}>
                <div className="d-flex">
                  <div className={`flex-shrink-0 ${item.iconbg}`}>
                    <i className={`fa ${item.icon} m-0`}></i>
                  </div>
                  <div className="flex-grow-1">
                    <Link to={`${process.env.PUBLIC_URL}/task`}>
                      <H5>{item.status}</H5>
                      <P>{item.name}</P>
                    </Link>
                  </div>
                  <span>{item.time}</span>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AuditLog;
